import AppliedDiscounts from './AppliedDiscounts'

export default AppliedDiscounts
